<template>
    <table class="table table-sm table-bordered">
        <tbody>
            <tr class="border-none">
                <td class="w-33 p-25" v-b-tooltip.hover.bottom.html="[
                    '<div class=\'text-left\'>',
                    [`Giriş: ${ row.LUCAGIRISTAR || '-' }`,`Çıkış: ${ row.LUCACIKISTAR || '-' }`,].join('<br/>'),
                    '</div>'
                    ].join('')"">
                    <b>L:</b>&nbsp;{{ $safe(row,'LUCAISYERI') || '-'  }}
                </td>
                <td class="w-33 p-25" v-b-tooltip.hover.bottom.html="[
                    '<div class=\'text-left\'>',
                    [`Giriş: ${ row.OBranchStartDate || '-' }`, `Çıkış: ${ row.OBranchEndDate || '-' }`,].join('<br/>'),
                    '</div>'
                    ].join('')">
                    <b>Org:</b>&nbsp;{{ $safe(row,'OBranchName') || '-' }}
                </td>
                <td class="w-33 p-25" v-b-tooltip.hover.bottom.html="[
                    '<div class=\'text-left\'>',
                    [`Giriş: ${ row.SGKBranchStartDate || '-' }`,`Çıkış: ${ row.SGKBranchEndDate || '-' }`,].join('<br/>'),
                    '</div>'
                    ].join('')">
                    <b>SGK:</b>&nbsp;{{ $safe(row,'SGKBranchName') || '-' }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
export default {
    directives:{
        'b-tooltip':VBTooltip
    },
    props:{
        row:Object,
        field:Object
    },
}
</script>